import OnlinePrePaymentReceipt from "../../../../components/card/paymentReceipt/onlinePrePaymentReceipt"

function OnlinePrePayment({ setStep }: any) {
    return (
        <div className='text-white mt-14 px-5'>
            <OnlinePrePaymentReceipt setStep={setStep} />
        </div>
    )
}

export default OnlinePrePayment